module.exports = __webpack_public_path__ + "static/media/logos_desktop.684cdaf7.webp";